module.exports = __webpack_public_path__ + "img/concrete-hole-decal-07.3c0e6324.png";